import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const resetPasswordUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`;

export default function ResetPasswordPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = new URLSearchParams(location.hash.replace("#", "")).get("token");

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!token) {
      setError("This reset link is incomplete. Request a new one from Cardfolio.");
      return;
    }
    if (password !== confirmation) {
      setError("Your new passwords need to match.");
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        resetPasswordUrl,
        { token, new_password: password },
        { withCredentials: true },
      );
      navigate("/dashboard", { replace: true, state: { user: response.data.user } });
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "This reset link is no longer valid.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="recovery-page" data-testid="reset-password-page">
      <section className="recovery-panel">
        <p className="eyebrow">New password</p>
        <h1 data-testid="reset-password-heading">Choose a secure password</h1>
        <p className="recovery-description" data-testid="reset-password-description">
          This link is private and expires in one hour.
        </p>
        <form className="recovery-form" onSubmit={submit} data-testid="reset-password-form">
          <label className="auth-field" data-testid="new-password-field">
            <span>New password</span>
            <input
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              type="password"
              autoComplete="new-password"
              minLength="8"
              placeholder="At least 8 characters"
              required
              data-testid="new-password-input"
            />
          </label>
          <label className="auth-field" data-testid="confirm-password-field">
            <span>Confirm new password</span>
            <input
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              type="password"
              autoComplete="new-password"
              minLength="8"
              placeholder="Repeat your new password"
              required
              data-testid="confirm-password-input"
            />
          </label>
          {error && <p className="auth-error" data-testid="reset-password-error">{error}</p>}
          <button
            className="email-submit-button"
            type="submit"
            disabled={isSubmitting}
            data-testid="reset-password-submit-button"
          >
            {isSubmitting ? "Saving…" : "Save new password"}
          </button>
        </form>
      </section>
    </main>
  );
}